var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWithdrawComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 112,
    viewBox: "0 0 108 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.920898 81.4642L59.6264 63.6836L83.5741 77.4872L47.2265 111.917L0.920898 81.4642Z",
    fill: "url(#paint0_linear_491_7692)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1086 6.8713L80.6378 19.0086V77.4844L56.4363 64.6124L57.1086 6.8713Z",
    fill: "#7F23F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_491_7692)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9102 0.0820312V61.7408L57.2473 62.4892L57.5411 7.72502L82.6592 21.7687V76.7119L87.0796 79.1859V17.6502L55.9102 0.0820312Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0793 79.1959L83.0642 81.7335L82.7722 19.6907L87.0793 17.4238V79.1959Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0793 79.1959L83.0642 81.7335L82.7722 19.6907L87.0793 17.4238V79.1959Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1 65.0222L54.6993 65.7425L54.4072 3.88401L57.4129 2.22266L57.1 65.0222Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.8296 2.46289V64.1217L54.7298 65.7568V7.64258L79.9452 22.2675L80.1481 80.0874L83.0764 81.7383L82.999 20.0311L51.8296 2.46289Z",
    fill: "#181818"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9649 0.128906C68.1374 6.98972 74.9068 10.5644 87.0792 17.4252L83.0887 20.1208L51.8076 2.5558L55.9649 0.128906Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_491_7692",
    x: 47.8076,
    y: 0.0820312,
    width: 43.272,
    height: 89.6562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_491_7692"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_491_7692",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_491_7692",
    x1: 58.921,
    y1: 67.3731,
    x2: 38.6927,
    y2: 102.772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7F23F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4625,
    stopColor: "#7F23F3",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F23F3",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWithdrawComplete);
export default __webpack_public_path__ + "static/media/icon_withdraw_complete.b719ae59bb06fa89028f1a42d01df67e.svg";
export { ForwardRef as ReactComponent };